import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { Directive } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { FirmService } from '../services/firm.service';

export function uniqueIdValidator(firmService: FirmService): AsyncValidatorFn {
  return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    if (!c.value) {
      return of(null);
    }
    let teamEditData, teamId;
    if (localStorage.getItem('teamMemberData')) {
      teamEditData = JSON.parse((localStorage.getItem('teamMemberData')));
    }
    if (localStorage.getItem('settingsUserAccessTeamMemberData')) {
      teamEditData = JSON.parse((localStorage.getItem('settingsUserAccessTeamMemberData')));
    }
    if (teamEditData) {
      teamId = teamEditData.id;
    }
    let debounceTime = 500; // milliseconds
    return timer(debounceTime).pipe(() => {
      if (teamId == c.value) {
        return of(null);
      } else {
        return firmService.validateMemberId(c.value).pipe(
          map(res => {
            return res.status !== 204 ? {'uniqueId': true} : null;
          }),
          catchError(() => of(null))
        );
      }
    });
  };
}

@Directive({
  selector: '[uniqueId][formControlName],[uniqueId][formControl],[uniqueId][ngModel]',
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: UniqueIdValidatorDirective, multi: true}],
  standalone: false
})
export class UniqueIdValidatorDirective implements AsyncValidator {
  constructor(private firmService: FirmService) { }

  validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return uniqueIdValidator(this.firmService)(c);
  }
}
